import StockA from "../../../images/stock/a.jpg";
import StockB from "../../../images/stock/b.jpg";
import StockC from "../../../images/stock/c.jpg";
import StockD from "../../../images/stock/d.jpg";
import StockE from "../../../images/stock/e.jpg";
import StockF from "../../../images/stock/f.jpg";
import StockG from "../../../images/stock/g.jpg";
import StockH from "../../../images/stock/h.jpg";

import AvatarA from "../../../images/avatar/a-sm.jpg";
import AvatarB from "../../../images/avatar/b-sm.jpg";
import AvatarC from "../../../images/avatar/c-sm.jpg";
import AvatarD from "../../../images/avatar/d-sm.jpg";

export const galleryData = [
  {
    id: 1,
    img: StockA,
    userImg: AvatarA,
    theme: "primary",
    userName: "Dustin Mock",
    userEmail: "mock@softnio.com",
    heart: 34,
  },
  {
    id: 2,
    img: StockB,
    userImg: null,
    theme: "pink",
    userName: "Ander Durham",
    userEmail: "ander@softnio.com",
    heart: 40,
  },
  {
    id: 3,
    img: StockC,
    userImg: AvatarB,
    theme: "pink",
    userName: "Krish Kendall",
    userEmail: "krish@softnio.com",
    heart: 349,
  },
  {
    id: 4,
    img: StockD,
    userImg: AvatarC,
    theme: "pink",
    userName: "Keith Jensen",
    userEmail: "keith@softnio.com",
    heart: 92,
  },
  {
    id: 5,
    img: StockE,
    userImg: null,
    theme: "indiggo",
    userName: "Heather Walker",
    userEmail: "walker@softnio.com",
    heart: 341,
  },
  {
    id: 6,
    img: StockF,
    userImg: AvatarD,
    theme: "indiggo",
    userName: "Asiya Wolff",
    userEmail: "asiya@softnio.com",
    heart: 139,
  },
  {
    id: 7,
    img: StockG,
    userImg: null,
    theme: "primary",
    userName: "Abu Bin Ishtiak",
    userEmail: "abu@softnio.com",
    heart: 149,
  },
  {
    id: 8,
    img: StockH,
    userImg: AvatarA,
    theme: "primary",
    userName: "Dustin Mock",
    userEmail: "mock@softnio.com",
    heart: 34,
  },
];
